import React, { type FC, memo } from 'react';

import type { Lucid } from '../../types/types';
import { TemplateCarousel } from './subcomponents/carousel/template-carousel';
import { TemplateGrid } from './subcomponents/grid/template-grid';
import { type LinkProps } from '../../types/components';

export interface TemplateSectionProps {
  /** Allows the component to get additional styles. */
  className?: string;
  /** The template cards */
  cards?: Lucid.Directus.Generated.Template_Card[];
  /** The section heading */
  heading?: string;
  /** Theme variant for the section heading */
  headingVariant?: Lucid.Theme.Component.Typography.Heading.VariantKeys;
  /** The section background color */
  backgroundColor?: Lucid.Theme.Color.ValueKeys | Lucid.Theme.Utility.ProductColorMap;
  /** The section CTA */
  link?: Lucid.Directus.Generated.Links & LinkProps;
  /** Supporting text for the section */
  text?: string;
  /** Forces the component to use a grid layout */
  shouldUseGrid?: boolean;
  /** Allows to pass in a Beacon event to the CTA link */
  beaconEvent?: Lucid.Beacon.Event;
}

const TemplateSection: FC<TemplateSectionProps> = memo(
  ({ backgroundColor = 'white', cards, headingVariant = 'heading2XL', shouldUseGrid, ...rest }) => {
    if (!cards) return null;

    const isGrid = cards.length < 12 || shouldUseGrid;

    return isGrid ? (
      <TemplateGrid {...rest} backgroundColor={backgroundColor} cards={cards} headingVariant={headingVariant} />
    ) : (
      <TemplateCarousel {...rest} backgroundColor={backgroundColor} cards={cards} headingVariant={headingVariant} />
    );
  },
);

export { TemplateSection };
export default TemplateSection;
